const { recommendSingleVehicleForOrder } = require("./recommendSingleVehicleForOrder");
/**
 * Bir sipariş için birden fazla aracı önerir ve bunları toplam maliyete göre sıralar.
 *
 * @param {Object} order - Sipariş detayları.
 * @param {Array} vehicles - Mevcut araçlar listesi.
 * @param {Array} customers - Müşteri bilgileri listesi.
 * @param {Array} products - Ürün bilgileri listesi.
 * @param {number} totalCount - Toplam adet değeri.
 * @param {Array} blockedVehicles - Önerilerden hariç tutulacak araçlar listesi.
 * @param {string} token - Kimlik doğrulama tokeni.
 * @returns {Promise<Array>} - Önerilen araçların maliyetlerine göre sıralanmış dizisi.
 */

async function recommendMultipleVehiclesForOrder(
    order,
    vehicles,
    customers,
    products,
    totalCount,
    blockedVehicles = [],
    isBulk = false,
    skipTheTonnage = false,
    setAvailable = true,
    blockedVehiclesParam = [],
    isClose = false,
    token,
    customerExpectedProducts = {},
    vehicleInventories = null
  ) {
    // Eğer vehicleInventories sağlanmadıysa, vehicles'dan otomatik oluştur
    if (!vehicleInventories) {
      const { getVehicleInventoryMap } = require('./helpers/getVehicleInventoryMap');
      vehicleInventories = getVehicleInventoryMap(vehicles);
    }

    try {

      const recommendedVehicles = await recommendSingleVehicleForOrder(
        order,
        vehicles,
        customers,
        products,
        totalCount,
        true,  // isBulk
        false, // skipTheTonnage
        false, // setAvailable
        blockedVehicles,
        false, // isClose
        token,
        customerExpectedProducts,
        vehicleInventories // Artık sabit katmandan geliyor
      );
      

      if (recommendedVehicles.REALLOCATION_NEEDED) {
        // recommendSingleVehicleForOrder'dan gelen bayrağı ve mesajı aynen döndür
        return recommendedVehicles;
      }

      // Eğer message property varsa, hata durumu olabilir
      if (recommendedVehicles.message) {
        console.warn("Recommendation message:", recommendedVehicles.message);
        return [];
      }

      if (!Array.isArray(recommendedVehicles)) {
        console.error("Invalid recommendation type received:", typeof recommendedVehicles, recommendedVehicles);
        return [];
      }
      return recommendedVehicles;
    } catch (error) {
      console.error("Error in vehicle recommendation:", error);
      return [];
    }
  }

  module.exports={
    recommendMultipleVehiclesForOrder
  }